import React, { useState } from "react";
import { Form, InputNumber } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import svg169 from "../../../../assets/svg/svg169.svg";
import img11 from "../../../../assets/img/img11.png";
import svg170 from "../../../../assets/svg/svg170.svg"; 
import svg150 from "../../../../assets/svg/svg150.svg";
import svg151 from "../../../../assets/svg/svg151.svg";
import { airtelPrefixes, safaricomPrefixes, telkomPrefixes, airtelLogo, telkomLogo } from "./data";

function Details({ form, handleCancel, handleProceed }) {
  const [phoneNumber, setPhoneNumber] = useState("");

  const getCarrierLogo = () => {
    const cleanNumber = phoneNumber?.replace(/[^0-9]/g, "");

    if (cleanNumber) {
      const prefix = cleanNumber.startsWith("254")
        ? cleanNumber.substring(3, 6)
        : cleanNumber.substring(1, 4);

      if (safaricomPrefixes.includes(prefix)) {
        return (
          <img
            src={img11}
            alt="Safaricom"
            className="w-[5.9375rem] h-[1.75rem] object-contain"
          />
        );
      } else if (airtelPrefixes.includes(prefix)) {
        return <img src={airtelLogo} alt="Airtel" className="w-[5.9375rem] h-[1.75rem] object-contain" />;
      } else if (telkomPrefixes.includes(prefix)) {
        return <img src={telkomLogo} alt="Telkom" className="w-[5.9375rem] h-[1.75rem] object-contain" />;
      }
    }

    return null;
  };
  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] ">
      <div className="flex items-center gap-[0.5rem]">
        <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-surface2 flex items-center justify-center">
          <img src={svg169} alt="svg169" />
        </div>
        <span className="text-ink font-[500] font-lexendS text-[0.875rem] leading-[1.5rem]">
          Details
        </span>
      </div>

      <Form.Item
        className="mt-[.69rem]"
        name="phoneNumber"
        label={"Enter Phone Number (Any Network)"}
        rules={[
          {
            required: true,
            message:
              "Please enter a valid phone number in the format +254XXXXXXXXX.",
          },
          {
            validator: (_, value) => {
              if (value && value.length === 12) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("Phone number must be exactly 10 characters")
              );
            },
          },
        ]}
      >
        <div className="relative">
          <PhoneInput
            country="ke"
            countryCodeEditable={false}
            value={phoneNumber}
            onChange={(value) => {
              setPhoneNumber(value);
              form.setFieldsValue({ phoneNumber: value });
            }}
            onKeyDown={(e) => {
              const input = e.target;
              const value = input.value?.replace(/[^0-9]/g, "");

              if (e.key === "0" && (!value || value === "254")) {
                e.preventDefault();
                return;
              }
              const allowedKeys = [
                "Backspace",
                "Delete",
                "ArrowLeft",
                "ArrowRight",
                "Tab",
              ];
              if (value && value.length >= 12 && !allowedKeys.includes(e.key)) {
                e.preventDefault();
              }
            }}
            className="input"
          />
          {getCarrierLogo() && (
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
              {getCarrierLogo()}
            </div>
          )}
        </div>
      </Form.Item>

      <Form.Item
        label="Enter Amount (KES)"
        name="amount"
        rules={[{ required: true, message: "Please enter amount" }]}
        extra={
          <span className="text-body text-[0.75rem] font-[400] leading-[1rem] font-lexendS">
            Minimum amount is KES 10.
          </span>
        }
      >
        <InputNumber
          prefix={<img src={svg170} alt="svg170" />}
          min={10}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          className="input flex"
        />
      </Form.Item>

      <div className="flex justify-end items-center gap-x-[0.5rem] mt-[1rem]">
        <button
          type="button"
          onClick={handleCancel}
          className="flex items-center gap-[0.5rem] rounded-[624.9375rem] border border-line bg-white py-[0.5rem] px-[1rem] text-ink text-[0.875rem] font-[500] leading-[1.25rem] font-lexendS"
        >
          <img src={svg150} alt="close" />
          Close
        </button>

        <button
          type="button"
          onClick={handleProceed}
          className="flex items-center gap-[0.5rem] rounded-[624.9375rem] bg-[#1E191B] py-[0.5rem] px-[1rem] text-white text-[0.875rem] font-[500] leading-[1.25rem] font-lexendS"
        >
          <img src={svg151} alt="buy" />
          Proceed
        </button>
      </div>
    </div>
  );
}

export default Details;
